import { navLinks, siteMeta, topics } from "@/mocks/guage";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-water-flash-fill text-xl"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-2xl text-foreground-950">{siteMeta.brand}</span>
                <span className="text-xs text-foreground-500 mt-1">{siteMeta.slogan}</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-md">
              {siteMeta.intro}
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href={`mailto:${siteMeta.email}`}
                rel="nofollow"
                className="flex items-center gap-2 px-3 py-2 rounded-md bg-background-50 border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line"></i>
                {siteMeta.email}
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-lg text-foreground-950 mb-4">站内导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-lg text-foreground-950 mb-4">主题分类</h4>
            <ul className="grid grid-cols-2 gap-2.5">
              {topics.map((topic) => (
                <li key={topic.name}>
                  <a
                    href="#topics"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {topic.name}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-xs text-foreground-500 leading-relaxed">
              {siteMeta.since}开张，专注于娱乐热点的锐评与复盘。内容仅代表个人观点，与事件当事人无关。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {year} {siteMeta.brand} · 保留所有权利
          </p>
          <p className="text-xs text-foreground-500">看热闹，更看门道</p>
        </div>
      </div>
    </footer>
  );
}